const wxApis$1 = ["sendChatMessage", "startRecord", "stopRecord", "playVoice", "pauseVoice", "stopVoice", "uploadVoice", "downloadVoice", "previewImage", "uploadImage", "downloadImage", "translateVoice", "getLocalImgData", "getNetworkType", "openLocation", "getLocation", "startAutoLBS", "stopAutoLBS", "hideOptionMenu", "showOptionMenu", "hideMenuItems", "showMenuItems", "hideAllNonBaseMenuItem", "showAllNonBaseMenuItem", "openDefaultBrowser", "scanQRCode", "selectEnterpriseContact", "openEnterpriseChat", "selectExternalContact", "getCurExternalContact", "openUserProfile", "shareAppMessage", "shareWechatMessage", "startWifi", "stopWifi", "connectWifi", "getWifiList", "getConnectedWifi", "getContext", "setClipboardData", "getCurExternalChat", "selectCorpGroupContact", "claimClassAdmin", "updateEnterpriseChat", "openExistedChatWithMsg", "hideChatAttachmentMenu", "setShareAttr", "getShareInfo", "createCorpGroupChat", "updateCorpGroupChat", "shareToExternalContact", "shareToExternalChat", "navigateToAddCustomer", "shareToExternalMoments", "updateMomentsSetting", "startMeeting", "startLiving", "replayLiving", "downloadLivingReplay", "createSchoolPayment", "closeWindow", "scanQRCode", "chooseImage", "previewFile", "openThirdAppServiceChat", "openBluetoothAdapter", "closeBluetoothAdapter", "getBluetoothAdapterState", "startBluetoothDevicesDiscovery", "stopBluetoothDevicesDiscovery", "getBluetoothDevices", "getConnectedBluetoothDevices", "createBLEConnection", "closeBLEConnection", "getBLEDeviceServices", "getBLEDeviceCharacteristics", "readBLECharacteristicValue", "writeBLECharacteristicValue", "notifyBLECharacteristicValueChange", "startBeaconDiscovery", "stopBeaconDiscovery", "onMenuShareAppMessage", "onMenuShareWechat", "onMenuShareTimeline", "onVoiceRecordEnd", "onVoicePlayEnd", "onNetworkStatusChange", "onLocationChange", "onHistoryBack", "onGetWifiList", "onWifiConnected", "onUserCaptureScreen", "onBluetoothAdapterStateChange", "onBluetoothDeviceFound", "onBLEConnectionStateChange", "onBLECharacteristicValueChange", "onBeaconUpdate", "onBeaconServiceChange"];

const warnLog = (...args) => {
  console.warn(...args);
};
const infoLog = (...args) => {
  console.info(...args);
};

/**
 * wx.fn 的异步调用方法
 * @param apiName wx.fn 的 fn 名
 * @param params 参数
 */

const asyncCall$1 = (apiName, params = {}) => {
  infoLog(`调用 wx.${apiName}，入参`, params);
  return new Promise((resolve, reject) => {
    const asyncCallParams = { ...params,
      success: res => resolve(res),
      fail: error => {
        warnLog(`调用 wx.${apiName} 出错，入参：`, params);
        warnLog(`调用 wx.${apiName} 出错，返回值：`, error.errMsg);
        reject(new Error(error.errMsg));
      },
      trigger: res => resolve(res),
      cancel: res => resolve(res),
      complete: res => resolve(res)
    }; // @ts-ignore

    window.wx[apiName](asyncCallParams);
  });
};

/**
 * wx.fn 的同步调用方法
 * @param apiName wx.fn 的 fn 名
 * @param params 参数
 */

const call$1 = (apiName, params = {}) => {
  infoLog(`调用 wx.${apiName}，入参`, params); // @ts-ignore

  return window.wx[apiName](params);
};

// 将 key1=val1&key2=val2 转成
// { key1: val1, key2: val2 }
const queryParse = queryStr => {
  const pairs = queryStr.split("&");
  return pairs.reduce((queryObj, pair) => {
    const [key, value] = pair.split("=");
    queryObj[key] = value;
    return queryObj;
  }, {});
};

// Cookie 调用
const cookies = {
  set: (key, value) => {
    document.cookie = `${key}=${value}`;
  },
  get: key => {
    const cookiePairs = document.cookie ? document.cookie.split("; ") : [];
    const cookieObj = {};
    cookiePairs.some(pair => {
      const [curtKey, ...curtValues] = pair.split("=");
      cookieObj[curtKey] = curtValues.join("="); // 有可能 value 存在 '='

      return curtKey === key; // 如果相等时，就会 break
    });
    return key ? cookieObj[key] : null;
  }
};

/**
 * 获取重定位的 OAuth 路径
 * @returns {string}
 */

const generateOAuthUrl = config => {
  const [redirectUri] = window.location.href.split("#");
  const searchObj = {
    appid: config.corpId,
    redirect_uri: encodeURIComponent(redirectUri),
    response_type: "code",
    scope: "snsapi_base",
    agentid: config.agentId,
    state: "A1"
  };
  const search = Object.entries(searchObj).map(entry => {
    const [key, value] = entry;
    return `${key}=${value}`;
  }).join("&");
  return `https://open.weixin.qq.com/connect/oauth2/authorize?${search}#wechat_redirect`;
};
/**
 * 判断当前网页是否需要重定向
 */


const checkRedirect$1 = async (config, getUserId) => {
  if (window._isMock) {
    // 使用 mock 的 userId
    if (window._mockUserId) {
      cookies.set("userId", window._mockUserId);
    }

    return;
  }

  const userId = cookies.get("userId");
  const unAuth = !userId || userId === "undefined" || userId === "null";
  const codeExist = window.location.search.includes("code"); // 判断是否需要重定向

  if (unAuth && !codeExist) {
    window.location.replace(generateOAuthUrl(config));
  } // 判断是否需要重新获取 userId


  if (unAuth) {
    const {
      code
    } = queryParse(window.location.search.slice(1));
    const newUserId = await getUserId(code || "");
    cookies.set("userId", newUserId);
  }
};

/**
 * jssdk 的 config 函数的封装
 * @param setting
 */

const configAndReady = setting => {
  return new Promise(resolve => {
    if (window._isMock) {
      console.log("调用 config，入参", setting);
      return resolve(null);
    }

    window.wx.config({ ...setting
    });
    window.wx.ready(() => resolve(null));
  });
};
/**
 * 初始化企业微信 SDK 库
 * config: 基础信息配置
 * getSignatures: 获取签名函数
 */


const initSdk$1 = async (config, getSignatures) => {
  const {
    corpId,
    agentId
  } = config; // 获取 ticket

  const signaturesRes = await getSignatures(); // wx.config & wx.ready

  await configAndReady({
    beta: true,
    debug: false,
    appId: config.corpId,
    timestamp: signaturesRes.meta.timestamp,
    nonceStr: signaturesRes.meta.nonceStr,
    signature: signaturesRes.corp.signature,
    jsApiList: wxApis$1 // 必填，需要使用的JS接口列表，凡是要调用的接口都需要传进来

  }); // wx.agentConfig

  return asyncCall$1("agentConfig", {
    corpid: corpId,
    agentid: agentId,
    timestamp: signaturesRes.meta.timestamp,
    nonceStr: signaturesRes.meta.nonceStr,
    signature: signaturesRes.app.signature,
    jsApiList: wxApis$1
  });
};

/**
 * 通用调用企业微信 SDK 的函数
 * @param apiName api 名称
 * @param params 传入参数
 */

const invoke$1 = (apiName, params = {}) => {
  infoLog(`调用 wx.invoke('${apiName}')，入参`, params);
  return new Promise((resolve, reject) => {
    const copiedParams = JSON.parse(JSON.stringify(params));
    window.wx.invoke(apiName, copiedParams, res => {
      const hasError = res.err_msg !== `${apiName}:ok` && res.err_msg !== `${apiName}:cancel`;

      if (hasError) {
        warnLog(`调用 wx.invoke('${apiName}') 出错，入参：`, copiedParams);
        warnLog(`调用 wx.invoke('${apiName}') 出错，返回值：`, res);
      }

      return hasError ? reject(new Error(res.err_msg)) : resolve(res);
    });
  });
};

// 默认是否为 mock 环境
const DEFAULT_IS_MOCK = !navigator.userAgent.toLowerCase().includes("wxwork"); // 默认 userId 的 mock

const DEFAULT_MOCK_USER_ID = "mock_user_id"; // 默认对 wx.fn 的 mock

const DEFAULT_WX_RES_MOCK = {}; // 默认对 wx.invoke('xxx') 的 mock

const DEFAULT_INVOKE_RES_MOCK = {};

// 手动设置是否是 Mock 环境
const setIsMock = isMock => {
  // 全局设置 Mock，自动判断 Mock，手动 Mock
  window._isMock = isMock || DEFAULT_IS_MOCK;
}; // 手动设置 mock 的 userId

const setMockUserId = mockUserId => {
  window._mockUserId = mockUserId || DEFAULT_MOCK_USER_ID;
}; // 设置 wx.fn 的 mock 结果

const setWxResMock = wxResMock => {
  window._wxResMock = wxResMock || DEFAULT_WX_RES_MOCK;
}; // 设置 wx.invoke 的 mock 结果

const setInvokeResMock = invokeResMock => {
  window._invokeResMock = invokeResMock || DEFAULT_INVOKE_RES_MOCK;
}; // 初始化

const initMock = () => {
  setIsMock();
  setMockUserId();
  setWxResMock();
  setInvokeResMock();
};

const wxApis = wxApis$1; // 重要类型

const asyncCall = async (apiName, params = {}) => {
  if (!window._isMock) {
    return asyncCall$1(apiName, params);
  }

  infoLog(`asyncCall: 调用 wx.${apiName}, 入参:`, params);
  const mockValue = window._wxResMock ? window._wxResMock[apiName] || "" : "";
  const mockRes = typeof mockValue === "function" ? await mockValue(apiName, params) : mockValue;
  infoLog(`asyncCall: 调用 wx.${apiName}, 返回:`, mockRes);
  return mockRes;
}; // 同步调用 wx.fn

const call = (apiName, params = {}) => {
  if (!window._isMock) {
    return call$1(apiName, params);
  }

  infoLog(`call: 调用 wx.${apiName}, 入参:`, params);
  const mockValue = window._wxResMock ? window._wxResMock[apiName] || "" : "";
  const mockRes = typeof mockValue === "function" ? mockValue(apiName, params) : mockValue;
  infoLog(`call: 调用 wx.${apiName}，返回:`, mockRes);
  return mockRes;
}; // 检查是否重定向，并设置 userId

const checkRedirect = async (config, getUserId) => {
  if (!window._isMock) {
    return checkRedirect$1(config, getUserId);
  }

  infoLog("checkRedirect: 当前 userId:", window._mockUserId);
}; // 初始化 SDK

const initSdk = async (config, getSignatures) => {
  if (!window._isMock) {
    return initSdk$1(config, getSignatures);
  }

  infoLog("initSdk: 传入配置:", config);
}; // 调用 wx.invoke

const invoke = async (apiName, params = {}) => {
  if (!window._isMock) {
    return invoke$1(apiName, params);
  }

  infoLog(`invoke: wx.invoke('${apiName}'), 入参:`, params);
  const mockValue = window._invokeResMock ? window._invokeResMock[apiName] || "" : "";
  const mockRes = typeof mockValue === "function" ? mockValue(apiName, params) : mockValue;
  infoLog(`invoke: 调用 wx.invoke('${apiName}'), 返回:`, mockRes);
  return mockRes;
};
initMock();

export { asyncCall, call, checkRedirect, initMock, initSdk, invoke, setInvokeResMock, setIsMock, setMockUserId, setWxResMock, wxApis };
